module.exports = __webpack_public_path__ + "static/img/14000476.6668ce4c.png";